import { getBrandedActionColors, isValidCssColor } from '@wavvest/shared-utils';
import type { BrandedActionColors } from '@wavvest/shared-utils';
import type { ThemeType } from '@/contexts/ThemeContext';

export { isValidCssColor };

const CLIENT_PAGE_BACKGROUND_COLOR: Record<ThemeType, string> = {
  dark: '#000000',
  light: '#ffffff',
};

const CLIENT_COMPONENT_BACKGROUND_COLOR: Record<ThemeType, string> = {
  dark: '#141414',
  light: '#f5f5f5',
};

const CLIENT_MENU_BACKGROUND_COLOR: Record<ThemeType, string> = {
  dark: '#7241894D',
  light: '#000000',
};

export const getClientPortalPrimaryActionColors = ({
  primaryColor,
  theme,
}: {
  primaryColor: string;
  theme: ThemeType;
}): BrandedActionColors =>
  getBrandedActionColors({
    primaryColor,
    surfaceColor: CLIENT_COMPONENT_BACKGROUND_COLOR[theme],
    pageBackgroundColor: CLIENT_PAGE_BACKGROUND_COLOR[theme],
  });

export const getClientPortalMenuActionColors = ({
  primaryColor,
  theme,
}: {
  primaryColor: string;
  theme: ThemeType;
}): BrandedActionColors =>
  getBrandedActionColors({
    primaryColor,
    surfaceColor: CLIENT_MENU_BACKGROUND_COLOR[theme],
    pageBackgroundColor: CLIENT_PAGE_BACKGROUND_COLOR[theme],
  });
